export default {"src":"/login-app/[GIT_HASH]/_next/static/media/snapshot.b59da87e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};